import { byPrefixAndName, type IconName, type IconPrefix } from '@awesome.me/kit-8363f9c1ab/icons';
import { forwardRef } from 'react';
import invariant from 'tiny-invariant';

import BaseIcon from './BaseIcon';
import { type BaseProps } from './types';

type Pack = 'solid' | 'regular' | 'light' | 'brands' | 'kit' | 'sharp' | 'sharp-regular';

export type Props = Omit<BaseProps, 'mask'> & {
    pack?: Pack;
    name: IconName;
    mask?: {
        name: IconName;
        pack?: Pack;
    };
};

const faPrefixToUnitySuffix = new Map<Pack, IconPrefix>([
    ['solid', 'fas'],
    ['regular', 'far'],
    ['light', 'fal'],
    ['brands', 'fab'],
    ['kit', 'fak'],
    ['sharp', 'fass'],
    ['sharp-regular', 'fasr'],
]);

const Icon = forwardRef<SVGSVGElement, Props>((props, ref) => {
    const { name, pack, mask, ...rest } = props;
    const prefix = faPrefixToUnitySuffix.get(pack || 'solid') || 'fas'; // Default to 'fas' if pack is missing or not recognized
    const maskPrefix = faPrefixToUnitySuffix.get(mask?.pack || 'solid') || 'fas'; // Default to 'fas' if mask pack is missing or not recognized

    const icon = byPrefixAndName[prefix]?.[name];
    const iconMask = mask ? byPrefixAndName[maskPrefix]?.[mask.name] : undefined;

    invariant(icon, `Icon with name "${name}" and pack "${pack}" not found.`);
    invariant(
        mask ? iconMask : true,
        `Icon mask with name "${mask?.name}" and pack "${mask?.pack}" not found.`,
    );

    return <BaseIcon {...rest} icon={icon} mask={iconMask} ref={ref} />;
});

export default Icon;
